import React from 'react';
import { AccountMenuListState } from '../../common/types';

const GetTabTTile = ({ item }: { item: AccountMenuListState }) => {
  return (
    <>
      {item.icon} {item.title}
    </>
  );
};

export default GetTabTTile;
